import type { IndustryContent } from '@/types/content';
import { getTestimonialsByIndustry } from '../testimonials';

export const hvacContent: IndustryContent = {
  slug: 'hvac',
  name: 'HVAC',
  headline: 'The Operating System for HVAC Companies',
  subheadline:
    'Dispatch smarter, track equipment, and manage maintenance agreements—all from one platform built for HVAC pros.',
  heroImageUrl: '/images/industries/hvac-hero.webp',
  painPoints: [
    {
      title: 'Dispatching is chaos',
      description:
        'Matching the right tech with the right skills to the right job takes too long. Callbacks are killing your margins.',
      icon: 'chaos',
    },
    {
      title: 'Maintenance agreements slip through the cracks',
      description:
        "You're leaving money on the table because renewals aren't automated and seasonal scheduling is a nightmare.",
      icon: 'calendar-x',
    },
    {
      title: "Equipment history is in someone's head",
      description:
        "When your senior tech is out, no one knows the customer's equipment history. Every call starts from scratch.",
      icon: 'brain',
    },
    {
      title: 'Techs waste time on paperwork',
      description:
        "They're filling out forms instead of turning wrenches. Then you're re-entering everything at the office.",
      icon: 'clipboard',
    },
  ],
  features: [
    {
      title: 'Smart Dispatch Board',
      description:
        'See tech locations, skills, and availability at a glance. Drag-and-drop scheduling with automatic route optimization.',
      icon: 'dispatch',
    },
    {
      title: 'Equipment Tracking',
      description:
        'Track every unit at every customer location. Serial numbers, install dates, warranty info, and service history—all searchable.',
      icon: 'equipment',
    },
    {
      title: 'Maintenance Agreements',
      description:
        'Automated renewals, seasonal scheduling, and revenue forecasting. Never miss a service visit or renewal.',
      icon: 'agreement',
    },
    {
      title: 'Mobile-First Experience',
      description:
        'Techs see job details, equipment history, and customer notes before they arrive. Capture photos, signatures, and payments on-site.',
      icon: 'mobile',
    },
    {
      title: 'Flat Rate Pricing',
      description:
        "Build and present flat rate pricing on the spot. Good/better/best options with photos that sell the job.",
      icon: 'pricing',
    },
    {
      title: 'QuickBooks Integration',
      description:
        'Invoices sync automatically. No more double-entry. Your books are always up to date.',
      icon: 'quickbooks',
    },
  ],
  testimonial: getTestimonialsByIndustry('hvac')[0],
  stats: [
    { label: 'Average Admin Time Saved', value: '50%' },
    { label: 'Faster Dispatch', value: '3x' },
    { label: 'Maintenance Agreement Retention', value: '95%' },
    { label: 'First-Call Resolution', value: '+25%' },
  ],
  seo: {
    title: 'HVAC Scheduling Software | Dispatch & Management | Omniforge',
    description:
      'HVAC software built for pros. Smart dispatch, equipment tracking, maintenance agreements, and mobile app. Start your free trial.',
    keywords: [
      'hvac scheduling software',
      'hvac dispatch software',
      'hvac business software',
      'hvac management software',
      'hvac service software',
    ],
  },
};
